(function () {
  if (window.__superBonsaiCartReady) return;
  window.__superBonsaiCartReady = true;

  function drawer() {
    return document.querySelector('[data-sb-cart-drawer]');
  }

  function openCart(trigger) {
    var root = drawer();
    if (!root) return;
    root.hidden = false;
    document.body.classList.add('sb-cart-is-open');
    document.querySelectorAll('[data-sb-cart-open]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'true');
    });
    var close = root.querySelector('[data-sb-cart-close]');
    if (close) close.focus();
  }

  function closeCart() {
    var root = drawer();
    if (!root) return;
    root.hidden = true;
    document.body.classList.remove('sb-cart-is-open');
    document.querySelectorAll('[data-sb-cart-open]').forEach(function (el) {
      el.setAttribute('aria-expanded', 'false');
    });
  }

  function setField(form, name, value) {
    var field = form.elements && form.elements.namedItem(name);
    if (field && field.tagName === 'INPUT') {
      field.value = value;
      return;
    }
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }

  function brandForm(form) {
    setField(form, 'properties[_commerce_brand]', 'superbonsai');
    setField(form, 'properties[_commerce_host]', window.location.host);
    setField(form, 'properties[_commerce_locale]', document.documentElement.lang || '');
  }

  function addUrl(action) {
    var url = new URL(action || '/cart/add', window.location.origin);
    url.pathname = url.pathname.replace(/\.js$/, '').replace(/\/$/, '') + '.js';
    return url.toString();
  }

  function cartChangeUrl() {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : '/';
    return root.replace(/\/$/, '') + '/cart/change.js';
  }

  function syncCartTrigger(doc) {
    var current = document.querySelector('.sb-cart-trigger');
    var next = doc.querySelector('.sb-cart-trigger');
    if (!current || !next) return;
    var oldCount = current.querySelector('.sb-cart-count');
    if (oldCount) oldCount.remove();
    var nextCount = next.querySelector('.sb-cart-count');
    if (nextCount) current.appendChild(nextCount.cloneNode(true));
  }

  async function refreshCart() {
    var response = await fetch(window.location.href, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    });
    if (!response.ok) throw new Error('Cart refresh failed');
    var html = await response.text();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var next = doc.querySelector('#SuperBonsaiCartDrawer');
    var current = document.querySelector('#SuperBonsaiCartDrawer');
    if (!next || !current) throw new Error('Cart drawer not found');
    current.replaceWith(next);
    syncCartTrigger(doc);
  }

  async function changeQuantity(group, quantity) {
    if (!group || group.dataset.sbUpdating === 'true') return;

    var line = parseInt(group.dataset.line || '', 10);
    var nextQuantity = Math.max(1, parseInt(quantity || '1', 10) || 1);
    if (!line) return;

    var input = group.querySelector('[data-sb-qty-input]');
    var wasOpen = drawer() && !drawer().hidden;
    group.dataset.sbUpdating = 'true';
    group.setAttribute('aria-busy', 'true');
    group.querySelectorAll('button, input').forEach(function (el) {
      el.disabled = true;
    });
    if (input) input.value = String(nextQuantity);

    try {
      var response = await fetch(cartChangeUrl(), {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ line: line, quantity: nextQuantity })
      });

      var data = null;
      try {
        data = await response.json();
      } catch (ignore) {}

      if (!response.ok) {
        throw new Error(
          (data && (data.description || data.message)) || 'Cart update failed'
        );
      }

      if (document.querySelector('.sb-cart-page')) {
        window.location.reload();
        return;
      }

      await refreshCart();
      if (wasOpen) openCart();
    } catch (error) {
      console.error(error);
      window.location.reload();
    }
  }

  function showError(form, message) {
    var lang = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    var fallback =
      lang === 'nl'
        ? 'Dit product kon niet aan de winkelwagen worden toegevoegd. Probeer het opnieuw.'
        : lang === 'de'
          ? 'Dieses Produkt konnte nicht zum Warenkorb hinzugefügt werden. Bitte versuchen Sie es erneut.'
          : 'This product could not be added to the basket. Please try again.';
    var host = form.closest('product-form');
    var wrapper = host && host.querySelector('.product-form__error-message-wrapper');
    var text = wrapper && wrapper.querySelector('.product-form__error-message');
    if (wrapper && text) {
      text.textContent = message || fallback;
      wrapper.hidden = false;
    } else {
      console.error(message || fallback);
    }
  }

  async function submitForm(form, trigger) {
    if (!form || form.dataset.sbSubmitting === 'true') return;

    brandForm(form);
    form.dataset.sbSubmitting = 'true';

    var button =
      trigger && trigger.form === form
        ? trigger
        : form.querySelector('[type="submit"]');
    var wasDisabled = button ? button.disabled : false;

    if (button) {
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
    }

    try {
      var response = await fetch(addUrl(form.action), {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: {
          Accept: 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        }
      });
      var data = null;
      try {
        data = await response.json();
      } catch (ignore) {}
      if (!response.ok) {
        throw new Error(
          (data && (data.description || data.message)) || 'Add to cart failed'
        );
      }
      await refreshCart();
      openCart(button);
    } catch (error) {
      showError(form, error && error.message);
    } finally {
      form.dataset.sbSubmitting = 'false';
      if (button) {
        button.removeAttribute('aria-busy');
        button.disabled = wasDisabled;
      }
    }
  }

  function nativeProductForm(node) {
    if (!node || !node.closest) return null;
    return node.closest('form[data-type="add-to-cart-form"]');
  }

  window.SuperBonsaiCart = {
    open: openCart,
    close: closeCart,
    refresh: refreshCart,
    submitForm: submitForm,
    changeQuantity: changeQuantity
  };

  // Capture native SuperBonsai ATC before document/body app handlers.
  window.addEventListener(
    'click',
    function (event) {
      var submitter =
        event.target &&
        event.target.closest &&
        event.target.closest(
          'form[data-type="add-to-cart-form"] button[type="submit"], form[data-type="add-to-cart-form"] input[type="submit"]'
        );
      if (!submitter) return;

      var form = submitter.form || nativeProductForm(submitter);
      if (!form || form.dataset.sbSubmitting === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      submitForm(form, submitter);
    },
    true
  );

  // Keyboard Enter and requestSubmit() still pass through the same guarded flow.
  window.addEventListener(
    'submit',
    function (event) {
      var form = nativeProductForm(event.target);
      if (!form || form.dataset.sbSubmitting === 'true') return;

      event.preventDefault();
      event.stopImmediatePropagation();
      submitForm(form, event.submitter || null);
    },
    true
  );

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-sb-cart-open]');
    if (opener) {
      event.preventDefault();
      openCart(opener);
      return;
    }
    if (event.target.closest('[data-sb-cart-close]')) {
      event.preventDefault();
      closeCart();
      return;
    }

    var minus = event.target.closest('[data-sb-qty-minus]');
    var plus = event.target.closest('[data-sb-qty-plus]');
    if (minus || plus) {
      event.preventDefault();
      var group = (minus || plus).closest('[data-sb-quantity]');
      var input = group && group.querySelector('[data-sb-qty-input]');
      if (!input) return;
      var value = parseInt(input.value || '1', 10) || 1;
      var nextValue = minus ? Math.max(1, value - 1) : value + 1;
      changeQuantity(group, nextValue);
    }
  });

  document.addEventListener('change', function (event) {
    var input =
      event.target && event.target.closest
        ? event.target.closest('[data-sb-qty-input]')
        : null;
    if (!input) return;
    var group = input.closest('[data-sb-quantity]');
    changeQuantity(group, input.value);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeCart();
  });
})();

/* Market-context homepages do not necessarily inherit the Custom Liquid loader
   from templates/index.json. Load the shared homepage enhancement globally on
   every SuperBonsai homepage so NL and DE stay aligned with the base homepage. */
(function () {
  if (window.__sbHomepageMarketLoaderRequested) return;
  if (!document.body || !document.body.classList.contains('template-index')) return;
  window.__sbHomepageMarketLoaderRequested = true;

  var current = document.currentScript;
  var src = current && current.src ? current.src : '';
  if (!src || src.indexOf('superbonsai-cart.js') === -1) return;

  var script = document.createElement('script');
  script.src = src.replace('superbonsai-cart.js', 'superbonsai-homepage-reviews.js');
  script.defer = true;
  document.head.appendChild(script);
})();

/* PDP-only localization for the duplicated SuperBonsai testimonial section. */
(function () {
  if (window.__sbPdpTestimonialsLocalizationReady) return;
  window.__sbPdpTestimonialsLocalizationReady = true;

  var translations = {
    en: {
      heading: '<h2>Customer reviews</h2>',
      reviews: [
        '<p>I didn\'t really notice a difference until we were out of it, about 2 wks without super liver &amp; I was dragging ASS!! My 18yo takes this religiously &amp; her grandma mentioned it seems to be clearing up her cystic acne. We\'re a big family so I buy in bulk, 2nd order for us, I\'m very happy I finally tried this product!!</p>',
        '<p><strong>I think it works!</strong></p><p>After several months of heavy drinking, I started taking Super Liver and cut back to one drink a day. Got a medical physical and ALL my blood work was NORMAL!! It is very helpful because I\'m feeling…</p>',
        '<p>I bought these on a whim, saw the ads and decided to give it a try and I am glad I took that chance! After a well, I felt noticeably better. I felt more alert, less sluggish and after 2+ weeks I saw an improvement in bloating, my face even started slimming down as well. Stay with it, it’s worth it!!</p>',
        '<p><strong>This literally is changing my life</strong></p><p>This literally is changing my life I stg my bloating went away like within a week my skin is evening out after being wrecked during pregnancy and im amazed. I can’t speak on the taste as I mix it in grapefruit juice so I can’t taste it but the results are actually shocking for me personally. I looked at this so long without ordering. My face less bloated too.</p>',
        '<p><strong>So easy and yummy!</strong></p><p>I love how easy Super Bonsai is to just add to a cup of water! I also really like adding it to a cup of water before I go to bed on a drinking night because I just feel like I legitimately wake up feeling better in the mornings when I have that before bed than when I forget!</p>'
      ]
    },
    nl: {
      heading: '<h2>Klantbeoordelingen</h2>',
      reviews: [
        '<p>Ik merkte eigenlijk pas verschil toen we zonder zaten. Na ongeveer 2 weken zonder Super Liver voelde ik me echt totaal futloos! Mijn 18-jarige neemt dit heel trouw en haar oma merkte op dat haar cystische acne lijkt op te klaren. We zijn een groot gezin, dus ik koop het in bulk. Dit is onze tweede bestelling en ik ben heel blij dat ik dit product uiteindelijk heb geprobeerd!</p>',
        '<p><strong>Ik denk dat het werkt!</strong></p><p>Na enkele maanden waarin ik veel dronk, begon ik Super Liver te gebruiken en minderde ik tot één drankje per dag. Ik kreeg een medische controle en AL mijn bloedwaarden waren NORMAAL!! Het helpt me erg, omdat ik me…</p>',
        '<p>Ik kocht dit impulsief nadat ik de advertenties had gezien en besloot het gewoon te proberen. Ik ben blij dat ik die kans heb genomen! Na een tijdje voelde ik me merkbaar beter. Ik voelde me alerter en minder futloos, en na ruim 2 weken merkte ik verbetering in mijn opgeblazen gevoel. Mijn gezicht leek zelfs slanker te worden. Blijf het gebruiken, het is het waard!!</p>',
        '<p><strong>Dit verandert letterlijk mijn leven</strong></p><p>Dit verandert echt mijn leven, ik zweer het. Mijn opgeblazen gevoel verdween binnen ongeveer een week en mijn huid wordt egaler nadat die tijdens mijn zwangerschap flink achteruit was gegaan. Ik ben echt verbaasd. Over de smaak kan ik niets zeggen, omdat ik het in grapefruitsap meng en het daardoor niet proef, maar de resultaten zijn voor mij persoonlijk echt verrassend. Ik heb hier zo lang naar gekeken zonder te bestellen. Mijn gezicht is ook minder opgeblazen.</p>',
        '<p><strong>Zo makkelijk en lekker!</strong></p><p>Ik vind het geweldig hoe makkelijk je Super Bonsai gewoon aan een glas water kunt toevoegen! Ik doe het ook graag in een glas water voordat ik naar bed ga op een avond waarop ik drink, omdat ik echt het gevoel heb dat ik de volgende ochtend beter wakker word als ik het voor het slapen neem dan wanneer ik het vergeet!</p>'
      ]
    },
    de: {
      heading: '<h2>Kundenbewertungen</h2>',
      reviews: [
        '<p>Ich habe den Unterschied eigentlich erst bemerkt, als wir nichts mehr davon hatten. Nach ungefähr 2 Wochen ohne Super Liver war ich total schlapp! Meine 18-Jährige nimmt es sehr konsequent, und ihre Oma meinte, dass ihre zystische Akne sich offenbar bessert. Wir sind eine große Familie, deshalb kaufe ich auf Vorrat. Das ist unsere zweite Bestellung, und ich bin sehr froh, dass ich dieses Produkt schließlich ausprobiert habe!</p>',
        '<p><strong>Ich glaube, es wirkt!</strong></p><p>Nachdem ich mehrere Monate viel Alkohol getrunken hatte, begann ich Super Liver zu nehmen und reduzierte auf ein Getränk pro Tag. Bei einer medizinischen Untersuchung waren ALLE meine Blutwerte NORMAL!! Es hilft mir sehr, weil ich mich…</p>',
        '<p>Ich habe es spontan gekauft, nachdem ich die Werbung gesehen hatte, und beschlossen, es einfach auszuprobieren. Ich bin froh, dass ich die Chance genutzt habe! Nach einer Weile fühlte ich mich spürbar besser. Ich war wacher und weniger schlapp, und nach über 2 Wochen bemerkte ich eine Verbesserung meines Blähgefühls. Sogar mein Gesicht wirkte schmaler. Bleib dran, es lohnt sich!!</p>',
        '<p><strong>Das verändert buchstäblich mein Leben</strong></p><p>Das verändert wirklich mein Leben, ich schwöre. Mein Blähgefühl war innerhalb von ungefähr einer Woche weg, und meine Haut wird ebenmäßiger, nachdem sie während der Schwangerschaft stark gelitten hatte. Ich bin wirklich erstaunt. Zum Geschmack kann ich nichts sagen, weil ich es in Grapefruitsaft mische und ihn dadurch nicht schmecke, aber die Ergebnisse sind für mich persönlich wirklich überraschend. Ich habe es mir so lange angesehen, ohne zu bestellen. Mein Gesicht ist auch weniger aufgedunsen.</p>',
        '<p><strong>So einfach und lecker!</strong></p><p>Ich finde es toll, wie einfach man Super Bonsai einfach in ein Glas Wasser geben kann! Ich gebe es auch gern vor dem Schlafengehen in ein Glas Wasser, wenn ich an dem Abend Alkohol trinke, weil ich wirklich das Gefühl habe, morgens besser aufzuwachen, wenn ich es vor dem Schlafengehen nehme, als wenn ich es vergesse!</p>'
      ]
    }
  };

  function locale() {
    var code = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
    return translations[code] ? code : 'en';
  }

  function targetSection() {
    return document.querySelector('[id$="__testimonials_superbonsai_pdp"]') ||
      document.querySelector('#shopify-section-testimonials_superbonsai_pdp');
  }

  function apply() {
    if (!document.body || !document.body.classList.contains('template-product--superbonsai')) return null;
    var root = targetSection();
    if (!root) return null;

    var t = translations[locale()];
    var heading = root.querySelector('[class*="testimonials-heading-"]');
    if (heading && heading.innerHTML.trim() !== t.heading) heading.innerHTML = t.heading;

    var cards = root.querySelectorAll('[class*="testimonials-card-"]');
    cards.forEach(function (card, position) {
      var rawIndex = card.getAttribute('data-swiper-slide-index');
      var index = rawIndex !== null && rawIndex !== '' ? parseInt(rawIndex, 10) : position;
      if (isNaN(index)) index = position;
      index = ((index % t.reviews.length) + t.reviews.length) % t.reviews.length;

      var text = card.querySelector('[class*="testimonials-text-"]');
      if (!text) return;
      var desired = t.reviews[index];
      if (text.innerHTML.trim() !== desired) text.innerHTML = desired;
    });

    return root;
  }

  function observe() {
    var root = apply();
    if (!root || root.dataset.sbPdpTestimonialsObserved === 'true') return;
    root.dataset.sbPdpTestimonialsObserved = 'true';

    var observer = new MutationObserver(function () {
      apply();
    });
    observer.observe(root, { childList: true, subtree: true });
  }

  function applyWithRetry() {
    observe();
    window.setTimeout(apply, 250);
    window.setTimeout(apply, 700);
    window.setTimeout(function () {
      observe();
      apply();
    }, 1400);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyWithRetry);
  } else {
    applyWithRetry();
  }

  document.addEventListener('shopify:section:load', applyWithRetry);
})();